<template>
  <div class="viu-he-error">
    <h1 class="viu-he-error__title" v-t.preserve="'auth.viuCallback.errorTitle'" />
    <p v-if="displayMessage" class="viu-he-error__message">{{ displayMessage }}</p>
    <a
      :href="browseHref"
      class="viu-he-error__home"
      @click.prevent="goHome"
    >{{ $t('auth.viuCallback.backHome') }}</a>
  </div>
</template>

<script>
import { viuPartnerErrorCodeToI18nSuffix } from '@/js/viuHeaderEnrichment'

export default {
  name: 'ViuHeaderEnrichmentError',
  computed: {
    browseHref() {
      return this.$router.resolve({ path: '/login/phone', query: {} }).href
    },
    displayMessage() {
      const q = this.$route.query
      const fromDesc = q.errorDesc != null ? String(q.errorDesc).trim() : ''
      if (fromDesc) {
        return fromDesc
      }
      const fromUnderscore = q.error_desc != null ? String(q.error_desc).trim() : ''
      if (fromUnderscore) {
        return fromUnderscore
      }
      const code = q.errorCode != null ? q.errorCode : q.error_code
      const suffix = viuPartnerErrorCodeToI18nSuffix(code != null ? String(code) : null)
      if (suffix === null) {
        return this.$t('auth.viuCallback.invalidHash')
      }
      return this.$t('auth.viuStatus.' + suffix)
    }
  },
  methods: {
    goHome() {
      // String location clears all query keys (e.g. ?hash=) unlike some named-route resolves.
      this.$router.replace('/login/phone').catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.viu-he-error {
  max-width: 560px;
  margin: 10rem auto 3rem;
  padding: 0 1.25rem;
  text-align: center;
  color: #453d4c;

  &__title {
    font-size: 1.5rem;
    margin-bottom: 1.25rem;
  }

  &__message {
    margin: 0.75rem 0;
    font-size: 1.05rem;
    line-height: 1.45;
  }

  &__home {
    display: inline-block;
    margin-top: 2rem;
    font-size: 1.1rem;
  }
}
</style>
